import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Head from 'next/head'
import { useMountGroup, useUnmountGroup } from 'src/features/filter-goods/model/core'
import { GoodsFilters } from 'src/widgets/good-filters/ui'
import { useGroupById } from 'src/features/goods-groups-update/hooks'

const Group = ({ groupId, title, isSearch = false }) => {
    const mountGroup = useMountGroup()
    const unmountGroup = useUnmountGroup()

    useEffect(() => {
        mountGroup()
        return () => {
            unmountGroup()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const group = useGroupById(groupId)

    return (
        <React.Fragment>
            {group && (
                <Head>
                    <title>{title} - купить товары в интернет-аптеке ЗДОРОВ.ру</title>
                </Head>
            )}
            <GoodsFilters />
        </React.Fragment>
    )
}

export default Group

Group.propTypes = {
    isSearch: PropTypes.bool,
    groupId: PropTypes.number.isRequired
}
